import { render } from "./Prediction.vue?vue&type=template&id=6fc97067&scoped=true"
import script from "./Prediction.vue?vue&type=script&lang=js"
export * from "./Prediction.vue?vue&type=script&lang=js"

import "./Prediction.vue?vue&type=style&index=0&id=6fc97067&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6fc97067"

export default script